import { apiClient } from './apiClient';
import type { DataMode } from '@/contexts/DataSourceContext';

export interface EmployeeRates {
  roleId: number | null;
  roleName: string | null;
  costRatePerHour: number | null;
  billRatePerHour: number | null;
  costRatePerDay: number | null;
  billRatePerDay: number | null;
  currency: string;
  effectiveFrom: string | null;
}

const mockEmployeeRates: EmployeeRates = {
  roleId: 1,
  roleName: 'Product',
  costRatePerHour: 20,
  billRatePerHour: 40,
  costRatePerDay: 160,
  billRatePerDay: 320,
  currency: 'GBP',
  effectiveFrom: '2024-01-01T00:00:00',
};

export async function getEmployeeRates(employeeId: number | string, mode: DataMode): Promise<EmployeeRates> {
  if (mode === 'demo') {
    return mockEmployeeRates;
  }
  return await apiClient.get<EmployeeRates>(`/employees/${employeeId}/rates`);
}
